import RecursosHospitalaresApi from '@/Apis/Agendamento/Services/RecursosHospitalaresApi'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'


const ResourceName = {
  Apa: 'ResourceAvaliacaoPreOperatoria',
}

@Module({ namespaced: true, name: 'RecursosHospitalaresStore' })
export default class RecursosHospitalaresStore extends VuexModule {
    public ResourceAccess: boolean = false


    @Mutation
    setResourceAccess(value: boolean) {
      this.ResourceAccess = value
    }

    @Mutation
    clearResourceAccess() {
      this.ResourceAccess = false
    }


    public ConfigResources: Record<string, Partial<typeof ResourceName>> = {
      ViewSolicitacaoCirurgia: {
        Apa: ResourceName.Apa,
      },
      ComponentModalTriagem: {
        Apa: ResourceName.Apa,
      },
    }


    get getResourceValue() {
      return (viewName: string, key: string): string | null => {
        const config = this.ConfigResources[viewName]
        if (!config) return null
        return config[key]
      }
    }

    @Action
    async getValidaAcessoRecurso({ hospitalId, medicoId, resourceName, cods }: { hospitalId: string; medicoId: string; resourceName: string, cods?: string[] }) {
      const res = await RecursosHospitalaresApi.getValidarAcessoRecurso(hospitalId, medicoId, resourceName, cods)
      if (res.data && !this.ResourceAccess) {
        this.context.commit('setResourceAccess', res.data)
        return true
      }
      return false
    }
}
